(function ($) {
    function addB02Class() {
        var b02Table = $(".b02-table");
        if (b02Table) {
            var hasMaximizedClass = $(".b02-table table").hasClass("table-maximized");
            if (hasMaximizedClass) {
                b02Table.parent().parent().addClass("b02-table-container");
            }
        }
    }
    addB02Class();
}(window.jQuery));

